import './icon-animations';



// WEBPACK FOOTER //
// ./resources/assets/js/animations/index.js